/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

interface AuthSessionStore {
  isSessionExpired: boolean
  setSessionExpired: (value: boolean) => void
}

export const useAuthSessionStore = create<AuthSessionStore>()(
  devtools(
    persist(
      set => ({
        isSessionExpired: false,
        setSessionExpired: value => set(state => ({ ...state, isSessionExpired: value })),
      }),
      {
        name: 'auth-session-store',
      }
    )
  )
)
